import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Radio } from 'semantic-ui-react';

// Components
import { FilterInput, FilterSelect, LabelSection } from 'components/NeoArea/NeoAreaFiltersBar/filterBarElements';

// Import services
import aclService from 'shared/lib/acl';
import CollaboratoriService from 'shared/services/rpc/gestione-collaboratore';
import { RECESSO_STATE } from 'containers/RecessiList/constantRecessi';
import { ACL } from 'shared/constants';

const initialState = {
  areaManager: '--',
  collaboratore: '',
  active: true,
  state: '--',
};

class FilterBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...initialState,

      areaManagerLoading: true,
      areaManagerOptions: [],
    };
  }

  componentDidMount() {
    CollaboratoriService.getResponsabiliByAgenzia(null)
      .then((res) => {
        const options = res.listaResponsabiliArea.map((option) => ({
          key: option.id,
          value: option.id,
          text: option.nominativo,
        }));
        const optionsWithNull = [{ key: 'empty', value: '--', text: '--' }].concat(options);
        this.setState({ areaManagerOptions: optionsWithNull, areaManagerLoading: false });
      })
      .catch(() => this.setState({ areaManagerLoading: false }));

    // TODO: This is a workaround. Please fix the datatable library.
    const th = document.querySelector('th[colspan="12"]');
    if (th) {
      th.setAttribute('colspan', this.props.colspan);
      // th.style.userSelect = 'none';
    }
  }

  /** Apply filters */
  onFilter = () => {
    const params = {
      areaManager: this.state.areaManager !== '--' ? this.state.areaManager : null,
      active: this.state.active || null,
      collaboratore: this.state.collaboratore !== '--' ? this.state.collaboratore : null,
      state: this.state.state !== '--' ? this.state.state : null,
    };

    this.props.onFilter(params);
  };

  /** Reset filters */
  onResetClick = () => this.setState({ ...initialState });


  /** Capture when enter keyboard is clicked */
  handleSearchEnter = (event) => {
    if (event.which === 13) {
      event.preventDefault();
      this.onFilter();
    }
  };

  render() {
    const { state, areaManagerOptions, active, areaManager, collaboratore } = this.state;
    const { auth, addRecesso } = this.props;

    // Define who can add a new recesso
    const canAddRecesso = aclService.check(auth, ACL.CAN_CREATE_RECESSO);

    // Check if user is area manager
    const isAreaManager = aclService.check(auth, ['responsabileArea']);

    return (
      <Grid onKeyDown={this.handleSearchEnter}>
        <Grid.Row>
          {!isAreaManager && (
            <Grid.Column width={3}>
              <FilterSelect
                label="Responsabile Area"
                value={areaManager}
                options={areaManagerOptions}
                onChange={(_event, { value }) => this.setState({ areaManager: value })}
              />
            </Grid.Column>
          )}
          <Grid.Column width={3}>
            <FilterInput
              label="Collaboratore"
              value={collaboratore}
              onChange={(_event, { value }) => this.setState({ collaboratore: value })}
            />
          </Grid.Column>
          <Grid.Column width={3}>
            <FilterSelect
              label="Stato"
              value={state}
              options={[
                { key: 'empty', value: '--', text: '--' },
                { key: '0', value: '0', text: RECESSO_STATE[0] },
                { key: '1', value: '1', text: RECESSO_STATE[1] },
                { key: '2', value: '2', text: RECESSO_STATE[2] },
                { key: '3', value: '3', text: RECESSO_STATE[3] },
                { key: '4', value: '4', text: RECESSO_STATE[4] },
                { key: '5', value: '5', text: RECESSO_STATE[5] },
                { key: '6', value: '6', text: RECESSO_STATE[6] },
              ]}
              onChange={(_event, { value }) => this.setState({ state: value })}
            />
          </Grid.Column>
          <Grid.Column width={3}>
            <LabelSection>Attivi</LabelSection>
            <Radio
              checked={active}
              toggle
              onChange={(_e, data) => this.setState({ active: data.checked })}
              style={{ marginTop: 8 }}
            />
          </Grid.Column>
          <Grid.Column width={4} textAlign="right" verticalAlign="bottom" floated="right">
            <Button
              content="Reset"
              icon="repeat"
              labelPosition="left"
              onClick={this.onResetClick}
              style={{ marginRight: 15 }}
            />
            <Button
              icon="search"
              labelPosition="left"
              content="Cerca"
              positive
              onClick={this.onFilter}
              style={{ marginRight: 15 }}
            />
            {canAddRecesso && (
              <Button icon="plus" labelPosition="left" primary content="Aggiungi" onClick={addRecesso} />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );

    // return <div>{canAddRecesso && <Button onClick={() => this.addRecesso()}>AGGIUNGI</Button>}</div>;
  }
}

FilterBar.propTypes = {
  // Manage auth
  auth: PropTypes.object,
  // Function to add new recesso
  addRecesso: PropTypes.func.isRequired,
  // Function to appyl filter
  onFilter: PropTypes.func.isRequired,
  colspan: PropTypes.number,
};

export default FilterBar;



// WEBPACK FOOTER //
// ./app/components/RecessoList/FilterBar/index.js